import { useTranslation } from "react-i18next";

import {BeforeGetStartedLandingCardStyled} from "./BeforeGetStartedStyled";
import { BeforeYouStart } from "../BeforeYouStart";
import { PsButtonTuner } from "stencilSetup";

interface BeforeGetStartedProps {
    startEnrollmentButton: (context: any) => void;
    context: any;
}

export const BeforeGetStarted = ({ startEnrollmentButton, context }: BeforeGetStartedProps) => {

    const { t } = useTranslation();

    return (
        <BeforeGetStartedLandingCardStyled className="card landing" data-testid="before-get-started-layout">
            <BeforeYouStart />

            <PsButtonTuner
              data-testid="start-enrollment-btn"
              buttonId="start-enrollment-btn"
              label={t('common:startEnrollmentButton')}
              extraClass="mt-5"
              level="primary"
              onClick={() =>
                startEnrollmentButton(context)
            }
            />
        </BeforeGetStartedLandingCardStyled>
    );
};
